<script setup lang="ts">
import TopicIndexPage from '../../components/topics/TopicPathIndexPage.vue'
import TopicGalleryPage from '../../components/topics/TopicPathGalleryPage.vue'
import TopicGalleryDetailPage from '../../components/topics/TopicPathGalleryDetailPage.vue'

const route = useRoute()

const pathSegments = computed(() => {
  const value = route.params.path
  return (Array.isArray(value) ? value : [value])
    .flatMap(segment => typeof segment === 'string' ? segment.split('/') : [])
    .map(segment => segment.trim())
    .filter(Boolean)
})

const galleriesIndex = computed(() => pathSegments.value.indexOf('galleries'))

const isGalleryRoute = computed(() => galleriesIndex.value >= 0 && pathSegments.value.length >= galleriesIndex.value + 2)
const isGalleryDetailRoute = computed(() => {
  if (!isGalleryRoute.value) {
    return false
  }

  const detailSegment = pathSegments.value[galleriesIndex.value + 2]
  return detailSegment === 'detail'
})

const activePageComponent = computed(() => {
  if (isGalleryDetailRoute.value) {
    return TopicGalleryDetailPage
  }

  if (isGalleryRoute.value) {
    return TopicGalleryPage
  }

  return TopicIndexPage
})
</script>

<template>
  <component :is="activePageComponent" :key="route.fullPath" />
</template>